import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslationService } from '@core/translation.service';
import { PublicContextService } from '@features/public/services/public-context.service';
import { PnycButtonComponent } from '@ui-kit/pnyc-button/pnyc-button.component';
import { LogoComponent } from '../logo/logo.component';
import { PRODIGY_LOGO_CONFIG, type LogoConfig } from '../logo/logo.constants';
import { locale } from './i18n/en';

@Component({
    selector: 'public-toolbar',
    templateUrl: './public-toolbar.component.html',
    styleUrl: './public-toolbar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LogoComponent, NgTemplateOutlet, PnycButtonComponent],
})
export class PublicToolbarComponent {
    private readonly publicContext = inject(PublicContextService);
    private readonly translationService = inject(TranslationService);

    readonly companyLogoConfig = computed((): LogoConfig => {
        const url = this.publicContext.companyLogoUrl();

        return url
            ? { name: this.publicContext.companyName() || PRODIGY_LOGO_CONFIG.name, logoPath: url, darkModeLogoPath: url }
            : PRODIGY_LOGO_CONFIG;
    });

    readonly isLogoPending = this.publicContext.companyLogoPending;
    readonly content = this.publicContext.toolbarContent;
    readonly isAuthorized = this.publicContext.isAuthorized;

    constructor() {
        this.translationService.loadTranslations(locale);
    }
}
